const linksGraphics = {
  Affaires: {
    statistics: [
      {
        name: "Nombre d'affaires/Origine",
        apiRequest: '/api/dealStatistics/nbDealsByOrigin/',
        graphQl: 'label, value',
        graphQlQuery: 'nbDealsByOrigin',
        axisBottom: 'origine',
        axisLeft: 'nb Affaires',
      },
      {
        name: 'PDC/Origine',
        apiRequest: '/api/dealStatistics/orderTakingByOrigin/',
        graphQl: 'label, value',
        graphQlQuery: 'orderTakingByOrigin',
        axisBottom: 'origine',
        axisLeft: 'PDC',
      },
      {
        name: "Nombre d'affaires/Type",
        apiRequest: '/api/dealStatistics/nbDealsByType/',
        graphQl: 'label, value',
        graphQlQuery: 'nbDealsByType',
        axisBottom: 'type',
        axisLeft: 'nb Affaires',
      },
      {
        name: "Nombre d'affaires créées/Mois",
        apiRequest: '/api/dealStatistics/nbDealsByMonth/',
        graphQl: 'label, value',
        graphQlQuery: 'nbDealsByMonth',
        axisBottom: 'Mois',
        axisLeft: 'nb Affaires',
      },
      {
        name: 'PDC/Type',
        apiRequest: '/api/dealStatistics/orderTakingByType/',
        graphQl: 'label, value',
        graphQlQuery: 'orderTakingByType',
        axisBottom: 'type',
        axisLeft: 'PDC',
      },
      {
        name: 'Marge/Mois (%)',
        apiRequest: '/api/dealStatistics/orderMarginPercent/',
        graphQl: 'label, value',
        graphQlQuery: 'orderMargin',
        axisBottom: 'Mois',
        axisLeft: 'Marge %',
      },
      {
        name: 'Marge/Mois (€)',
        apiRequest: '/api/dealStatistics/orderMargin/',
        graphQl: 'label, value',
        graphQlQuery: 'orderMargin',
        axisBottom: 'Mois',
        axisLeft: 'Marge €',
      },
      {
        name: 'PDC/Mois - création',
        apiRequest: '/api/dealStatistics/orderTakingCreatedByMonth/',
        graphQl: 'label, value',
        graphQlQuery: 'orderTakingCreatedByMonth',
        axisBottom: 'Mois',
        axisLeft: 'PDC',
      },
      {
        name: 'PDC/Mois - cloture',
        apiRequest: '/api/dealStatistics/orderTakingClosedByMonth/',
        graphQl: 'label, value',
        graphQlQuery: 'orderTakingClosedByMonth',
        axisBottom: 'Mois',
        axisLeft: 'PDC',
      },
      {
        name: 'Portefeuille',
        apiRequest: '/api/dealStatistics/wallet/',
        graphQl: 'label, value',
        graphQlQuery: 'wallet',
        axisBottom: 'Etat',
        axisLeft: 'PDC',
      },
    ],
  },
  Comptes: {
    statistics: [
      {
        name: 'Nombre de comptes/Mois ',
        apiRequest: '/api/bookStatistics/nbAccountsByMonth/',
        graphQl: 'label, value',
        graphQlQuery: 'nbAccountsByMonth',
        axisBottom: 'Mois',
        axisLeft: 'nb Comptes',
      },
      {
        name: 'Nombre de comptes/Domaine professionnel ',
        apiRequest: '/api/bookStatistics/nbAccountsByProfessionalField/',
        graphQl: 'label, value',
        graphQlQuery: 'nbAccountsByProfessionalField',
        axisBottom: 'Mois',
        axisLeft: 'Domaine',
      },
    ],
  },
  Contacts: {
    statistics: [
      {
        name: 'Nombre de contacts/Mois ',
        apiRequest: '/api/bookStatistics/nbContactsByMonth/',
        graphQl: 'label, value',
        graphQlQuery: 'nbContactsByMonth',
        axisBottom: 'Mois',
        axisLeft: 'nb Contacts',
      },
      {
        name: 'Nombre de contacts/Origine',
        apiRequest: '/api/bookStatistics/nbContactsByOrigin/',
        graphQl: 'label, value',
        graphQlQuery: 'nbContactsByOrigin',
        axisBottom: 'origine',
        axisLeft: 'nb Contacts',
      },
    ],
  },
  Tickets: {
    statistics: [
      {
        name: 'Nombre de tickets/Mois',
        apiRequest: '/api/supportStatistics/nbTicketsByMonth/',
        graphQl: 'label, value',
        graphQlQuery: 'nbTicketsByMonth',
        axisBottom: 'Mois',
        axisLeft: 'nb tickets',
      },
      {
        name: 'Nombre de tickets/Résolution',
        apiRequest: '/api/supportStatistics/nbTicketsByClosedReason/',
        graphQl: 'label, value',
        graphQlQuery: 'nbTicketsByClosedReason',
        axisBottom: 'Raison',
        axisLeft: 'nb tickets',
      },
      {
        name: "Nombre de tickets/Type d'incident",
        apiRequest: '/api/supportStatistics/nbTicketsByIncidentType/',
        graphQl: 'label, value',
        graphQlQuery: 'nbTicketsByIncidentType',
        axisBottom: "Type d'incident",
        axisLeft: 'nb tickets',
      },
      {
        name: 'Nombre de tickets/Fournisseur',
        apiRequest: '/api/supportStatistics/nbTicketsBySupplierOfProduct/',
        graphQl: 'label, value',
        graphQlQuery: 'nbTicketsBySupplierOfProduct',
        axisBottom: 'Fournisseur',
        axisLeft: 'nb tickets',
      },
      {
        name: 'Nombre de tickets/Type de service',
        apiRequest: '/api/supportStatistics/nbTicketsByProductType/',
        graphQl: 'label, value',
        graphQlQuery: 'nbTicketsByProductType',
        axisBottom: 'Service',
        axisLeft: 'nb tickets',
      },
    ],
  },
  'Rendez-vous': {
    statistics: [
      {
        name: 'Nombre de Rdv/Type',
        apiRequest: '/api/collaborativeStatistics/nbAppointmentsByType/',
        graphQl: 'label, value',
        graphQlQuery: 'nbAppointmentsByType',
        axisBottom: 'Type',
        axisLeft: 'nb rendez-vous',
      },
    ],
  },
  Tâches: {
    statistics: [],
  },
  Rappels: {
    statistics: [],
  },
};

export default linksGraphics;
